var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeyWedding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0046 3.3252C9.34382 4.92481 9.52052 8.47863 9.87235 10.8658C9.91247 11.138 9.94754 11.376 9.98556 11.5873L2.42671 18.8676C1.85776 19.4156 1.85776 20.3041 2.42671 20.8521C2.99566 21.4001 3.91811 21.4001 4.48706 20.8521L5.11618 20.2461L6.63578 21.7095C7.03809 22.0969 7.69031 22.0968 8.09259 21.7094L8.82103 21.0078C9.22337 20.6203 9.22334 19.992 8.82096 19.6045L7.30151 18.1413L8.11861 17.3543L8.90945 18.1162C9.31175 18.5038 9.96411 18.5038 10.3665 18.1163L11.0066 17.4997C11.4088 17.1123 11.4088 16.4841 11.0066 16.0966L10.2156 15.3346L12.0459 13.5717C12.2653 13.6084 12.5124 13.6421 12.795 13.6808C15.2735 14.0197 18.9633 14.1898 20.6241 12.5902C23.3986 9.91793 21.789 6.37228 17.4815 6.35204C17.4604 2.20318 13.7791 0.652925 11.0046 3.3252Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyWedding);
export default __webpack_public_path__ + "static/media/key-wedding.13a12f49121ddfddf40c2188ca5af846.svg";
export { ForwardRef as ReactComponent };